require('./bootstrap');
import NotificationTracker from "./alpine-components/NotificationTracker";
import CardComponent from "./alpine-components/CardComponent";
import ModalComponent from "./alpine-components/ModalComponent";
import ProductComponent from "./alpine-components/ProductComponent";
import CartComponent from "./alpine-components/CartComponent";

window.cardUtils = {
    errors: {
        card_number: 'O número do cartão de crédito fornecido é inválido',
        card_cvv: 'O CVV do cartão de crédito é inválido',
        card_expiration_date: 'A data de vencimento do cartão de crédito é inválida',
        card_holder_name: 'Nome fornecido é inválido',
    },
    getErrorMessage: function (error) {
        return this.errors[error];
    },
};

window.notificationTracker = NotificationTracker;
window.cardComponent = CardComponent;
window.modalComponent = ModalComponent;
window.productComponent = ProductComponent;
window.cartComponent = CartComponent;
window.addEventListener('load', function() {
    window.loadingOverlay = document.getElementById('loading-overlay');
    const emitCallback = (data) => {
        let emit = data.emit;
        let dispatch = data.dispatch;
        if (emit) {
            Livewire.emit(emit.event, emit.data);
        }

        if (dispatch) {
            window.dispatchEvent(new CustomEvent(dispatch.event, {detail : dispatch.data}))
        }
    }

    Livewire.on('load-script', function (event) {
        if(document.getElementById(event.id)) {
            return emitCallback(event)
        }
        loadScript(event.id, event.src, event.async, () => emitCallback(event))
    });

    Livewire.on('load-scripts', function (data) {
        data.forEach((event) => {
            if(document.getElementById(event.id)) {
                emitCallback(event)
            } else {
                loadScript(event.id, event.src, event.async, () => emitCallback(event));
            }
        })
    });

    Livewire.on('remove-script', function (event) {
        document.getElementById(event.detail.id).remove();
    })

    Livewire.on('loading-start', function () {
        window.loadingOverlay.style.display = '';
    });

    Livewire.on('loading-stop', function () {
        window.loadingOverlay.style.display = 'none';
    });

    Livewire.on('open-push-url', function (event) {
        window.location = event.data;
    });

    Livewire.on('copy-to-clipboard', function (event) {
        const text = event.text;
        if (navigator.clipboard && window.isSecureContext) {
            // Use the modern Clipboard API
            navigator.clipboard.writeText(text).then(function() {
                console.log('Text copied to clipboard');
            }).catch(function(err) {
                console.error('Failed to copy text: ', err);
            });
        } else {
            // Fallback for older browsers
            const textArea = document.createElement('textarea');
            textArea.value = text;
            textArea.style.position = 'fixed';
            textArea.style.left = '-999999px';
            textArea.style.top = '-999999px';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                document.execCommand('copy');
                console.log('Text copied to clipboard');
            } catch (err) {
                console.error('Failed to copy text: ', err);
            }
            document.body.removeChild(textArea);
        }
    });


    document.querySelectorAll('[x-tooltip]').forEach(item => {

        item.addEventListener('mouseenter', event => {
            if (window.tooltipEl) return;
            window.tooltipEl = window.document.createElement('div');
            window.tooltipEl.id = 'tooltip';
            window.tooltipEl.className = 'z-50 p-2 m-1 absolute text-sm text-white bg-black opacity-75 rounded-lg shadow-lg w-max';
            window.tooltipEl.innerHTML = item.getAttribute('x-tooltip');
            let pos = event.target.getBoundingClientRect()
            let left = (parseInt(pos.left) - window.tooltipEl.offsetWidth < 0) ? 20 : parseInt(pos.left) - 20 - window.tooltipEl.offsetWidth;
            let top = parseInt(pos.top) - window.tooltipEl.offsetHeight - 20;
            left = (left < 0) ? parseInt(pos.left) : left;
            top = (top < 0) ? parseInt(pos.bottom) + 20 : top;
            window.document.body.appendChild(window.tooltipEl);
            window.tooltipEl.style.left = left + 'px';
            window.tooltipEl.style.top = top + 'px'
        })

        item.addEventListener('mouseleave', event => {
            setTimeout(function () {
                if (window.tooltipEl) window.tooltipEl.remove();
                window.tooltipEl = null
            }, 200);
        });
    })
});

// Initialize the service worker
if ('serviceWorker' in navigator) {
    let path = window.location.pathname.replace('/', '');
    navigator.serviceWorker.register('/serviceworker.js?id=' + window.serviceworker_version + '&for='+ path.substr(0,path.indexOf('/')), {
        scope: '/'
    }).then(function (registration) {
    }, function (err) {
    });

    navigator.serviceWorker.onmessage = function(event){
        Livewire.emit(event.data.name, event.data.data);
    };
}

window.isIos = () => {
    return navigator.userAgent.indexOf("Safari") > -1 && navigator.userAgent.indexOf('Chrome') === -1;
}

window.isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);


if (!window.isInStandaloneMode()) {
    if (window.isIos()) {
        [
            {element : 'install-banner', display : ''},
            {element : 'install-button-container', display : 'none'},
            {element : 'install-subtext', display: 'none'},
            {element : 'install-subtext-ios', display: ''},
            {element : 'install-banner-ios', display: ''}
        ].forEach(function (item) {
            const el = document.getElementById(item.element);

            if (el) {
                el.style.display = item.display;
            }
        });
    } else {
        window.addEventListener('beforeinstallprompt', (event) => {
            event.preventDefault();
            window.deferredPrompt = event;
            const el = document.getElementById('install-banner');
            if (el) {
                el.style.display = '';
                const button = document.getElementById('install-button');
                if (button) {
                    button.addEventListener('click', async () => {
                        const promptEvent = window.deferredPrompt;
                        if (!promptEvent) {
                            return;
                        }
                        promptEvent.prompt();
                        const result = await promptEvent.userChoice;
                        window.deferredPrompt = null;
                        el.style.display = 'none';
                    });
                }
            }
        });

        window.addEventListener('appinstalled', (event) => {
            // Clear the deferredPrompt so it can be garbage collected
            window.deferredPrompt = null;
            const el = document.getElementById('install-banner');
            if (el) {
                el.style.display = 'none';
            }
        });
    }


}

window.setCookie = function (cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
window.getCookie = function(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
window.imagesLoaded = [];
window.addEventListener('livewire:load', function() {
    window.Turbolinks.start()
    document.getElementById('lock-loading').style.display = 'none';
})

window.addEventListener('load', function() {
    document.getElementById('lock-loading').style.display = 'none';
})